import { render, staticRenderFns } from "./MdView.vue?vue&type=template&id=2ec3e8de&"
import script from "./MdView.vue?vue&type=script&lang=js&"
export * from "./MdView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports